import { track } from '../facade';

const dispatch = (action, label = null, value = null) => track(action, {
  category: `Checkout 2.0`,
  label,
  value
});

export const trackGeneralClick = (component, page) => dispatch(`Clicked ${component} - on ${page} page`);
export const trackClickField = (field, value) => {
  dispatch(`Shipping Details - Clicked into ${field} field`, field, value);
};
export const trackSelectedShippingMethod = (field, value) => {
  dispatch(`Shipping Methods - Selected ${value} shipping method`, field, value);
};
export const trackCheckoutSubmitButton = (page, button) => dispatch(`Submit button clicked on ${page} page`, button);
export const trackAccordion = (action, componentName) => dispatch(`${action} ${componentName} accordion`);
export const trackErrors = error => dispatch(`Error: ${error}`);

export const trackPaymentButtonClick = (method) => dispatch('Payment Method', `Selected ${method} as a payment method`);
